import script from "./Text.vue?vue&type=script&lang=ts&setup=true"
export * from "./Text.vue?vue&type=script&lang=ts&setup=true"

import "./Text.vue?vue&type=style&index=0&id=0c792d18&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c792d18"]])

export default __exports__